module.exports = __webpack_public_path__ + "img/expression1.bfa8e957.png";